import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PaymentsService } from 'src/app/payments/services/payments.service';
import { ToastrProviderService } from '@services/toastr-provider.service';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CurrencyType, Client } from '@enums/enum';
import { User } from '@entities/user';
import { environment } from '@environment';
import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-licensing-users',
    templateUrl: './licensing-users.component.html',
    styleUrls: ['./licensing-users.component.scss'],
})
export class LicensingUsersComponent implements OnInit {
    public readonly usersFee: number = 199;
    private to: string;
    public licensing$!: Observable<any>;
    public usersCount: number = 0;
    public CurrencyType = CurrencyType;
    public tableMessages = {
        emptyMessage: this.translateService.instant('No data to display'),
    };

    public excludes: string;
    public includes: string;

    public columns = [
        { prop: 'username', name: this.translateService.instant('Username'), flexGrow: 4 },
        { prop: 'firstName', name: this.translateService.instant('Firstname'), flexGrow: 2 },
        { prop: 'lastName', name: this.translateService.instant('Lastname'), flexGrow: 2 },
        { prop: 'createdAt', name: this.translateService.instant('Created at'), flexGrow: 2 },
    ];

    constructor(private route: ActivatedRoute, private translateService: TranslateService, private paymentService: PaymentsService) {}

    public ngOnInit() {
        if (environment.client === Client.FRISCO) {
            this.includes = '%frisco.pl';
        }

        this.route.queryParams.subscribe((params) => {
            if (params['from'] && params['to']) {
                this.to = moment(params['to']).format('YYYY-MM-DD');
                this.fetechLicensingUsers();
            }
        });
        this.fetechLicensingUsers();
    }

    private fetechLicensingUsers() {
        this.licensing$ = this.paymentService.licensingUsers(this.to, this.excludes, this.includes).pipe(tap((u: User[]) => (this.usersCount = u.length)));
    }

    public changeFilters(): void {
        this.fetechLicensingUsers();
    }

    /**
     * Exports licensing user data to an Excel (.xlsx) file using ExcelJS.
     * The file is named based on the `to` date value passed in the component.
     *
     * @param licensing - Array of users whose license data will be exported.
     */
    public async exportToXls(licensing: User[]): Promise<void> {
        const data = this.getDataToExport(licensing);

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Users');

        if (data.length > 0) {
            worksheet.columns = Object.keys(data[0]).map((key) => ({
                header: key,
                key: key,
                width: 20,
            }));

            data.forEach((row) => worksheet.addRow(row));
            worksheet.getRow(1).font = { bold: true };
        }

        const buffer = await workbook.xlsx.writeBuffer();
        const date = moment().format('YYYY-MM-DD');
        const filename = `Users-${this.to}.xlsx`;
        const blob = new Blob([buffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });

        saveAs(blob, filename);
    }

    private getDataToExport(users: User[]) {
        const routeData = [];

        for (const item of users) {
            routeData.push({
                Imię: item.firstName,
                Nazwisko: item.lastName,
                'Adres e-mail': item.username,
                'Data utworzenia': item['createdAt'],
            });
        }

        return routeData;
    }
}
